import React from 'react';

/**
 * Report primitives. Mirrors the prototype's `.subtab-bar` / `.subtab` /
 * `.table-scroll` / `.section-heading`.
 *
 *  <SubTabBar>
 *      <SubTab active>Rewired</SubTab>
 *      <SubTab>PAMM</SubTab>
 *  </SubTabBar>
 *
 *  <SectionHeading>Rewired accounts</SectionHeading>
 *
 *  <TableScroll>
 *      <table>...</table>
 *  </TableScroll>
 */
export const SubTabBar = ({children, className = '', ...rest}) => {
    const cn = ['subtab-bar', className].filter(Boolean).join(' ');
    return (
        <div className={cn} {...rest}>
            {children}
        </div>
    );
};

export const SubTab = ({active, children, className = '', ...rest}) => {
    const cn = ['subtab', active ? 'active' : '', className].filter(Boolean).join(' ');
    return (
        <div className={cn} {...rest}>
            {children}
        </div>
    );
};

export const TableScroll = ({children, className = '', ...rest}) => {
    const cn = ['table-scroll', className].filter(Boolean).join(' ');
    return (
        <div className={cn} {...rest}>
            {children}
        </div>
    );
};

export const SectionHeading = ({children, className = '', ...rest}) => {
    const cn = ['section-heading', className].filter(Boolean).join(' ');
    return (
        <div className={cn} {...rest}>
            {children}
        </div>
    );
};
